const jwVideo = state => state.jwVideo
const playingVideoId = state => state.playingVideoId
const playingVideoTime = state => state.playingVideoTime
const isWatchingFullscreen = state => state.isWatchingFullscreen
const currentQuizId = state => state.currentQuizId

export default {
  jwVideo,
  playingVideoId,
  playingVideoTime,
  isWatchingFullscreen,
  currentQuizId,
}
